import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "../al_components/ALLink";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { gaCustomEvent } from "../../context/helpers";
import * as popularCategoriesStyles from "./popularCategories/popularCategoriesStyles.module.scss";

function PopularCategories({ content, componentType }) {
  const onLinkClick = (title) => {
    gaCustomEvent("Popular Categories", "Click", title);
  };

  const additionalClassName = componentType
    ? `${popularCategoriesStyles[componentType.toLowerCase()]}`
    : "";

  if (content) {
    return (
      <div
        className={`${popularCategoriesStyles.container} ${additionalClassName} id-${content.contentful_id}`}
      >
        <h2 className={`${popularCategoriesStyles.container_title} h2 h2--bold`}>
          {content.title}
        </h2>
        <div className={popularCategoriesStyles.categories}>
          {content.collections.map((c, i) => (
            <Link
              className={popularCategoriesStyles.categories_category}
              key={`home_popular_categories_${i}`}
              to={c.link.link.link}
              onClick={() => onLinkClick(c.title)}
            >
              <div className={popularCategoriesStyles.categories_category_image}>
                <GatsbyImage
                  className={popularCategoriesStyles.categories_category_image_img}
                  image={getImage(c.images[0].desktopImage.gatsbyImageData)}
                  alt={c.images[0].altText}
                />
              </div>
              <h3 className={`${popularCategoriesStyles.categories_category_title} h3`}>
                {c.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    );
  }
  return null;
}

export default withALErrorBoundary({
  name: "PopularCategories",
  priority: "P2",
})(PopularCategories);
